import React, { useState, useEffect } from "react";
/* import { WalletMultiButton } from "@solana/wallet-adapter-react-ui"; */
import { setVisible } from "@solana/wallet-adapter-react-ui";
import { useWalletModal } from "@solana/wallet-adapter-react-ui";
import { Box, Button, HStack, Image, useToast } from "@chakra-ui/react";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { Connection, Keypair, LAMPORTS_PER_SOL } from "@solana/web3.js";

const ConnectButton = () => {
  const toast = useToast();
  const { setVisible } = useWalletModal();
  const { publicKey, connecting, connected, disconnect } = useWallet();
  const connect = () => {
    setVisible(true);
  };

  const connection = new Connection(
    `https://solana-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY}`
  );

  const disconnectWallet = () => {
    toast({
      title: "Disconnected",

      status: "error",
      duration: 9000,
      isClosable: true,
    });
    disconnect();
  };

  const [balance, setBalance] = useState(null);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const balance = await connection?.getBalance(publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      } catch (error) {}
    };

    fetchBalance();

    // Cleanup function to cancel async operation (if necessary)
    return () => {
      // Cleanup code (if necessary)
    };
  }, [connection, publicKey]);

  return (
    <div>
      <Button
        p="10px"
        size="md"
        isLoading={connecting}
        onClick={connected ? () => disconnectWallet() : () => connect()}
        borderRadius="10px"
      >
        {connected ? (
          <>
            <HStack alignItems="center">
              <HStack>
                <Box>
                  <Image
                    boxSize="20px"
                    src="https://router.via.exchange/assets/img/avatar-33d0a375.png"
                  />
                </Box>
                <Box fontWeight="600">{Number(balance)?.toFixed(1)}SOL</Box>
              </HStack>

              <Box
                display={{ base: "none", md: "flex" }}
                p="6px"
                bg="#2d2d2d"
                borderRadius="6px"
              >
                {` ${String(publicKey)?.slice(0, 8)}...`}
              </Box>
              <Box
                display={{ base: "flex", md: "none" }}
                p="6px"
                bg="#2d2d2d"
                borderRadius="6px"
              >
                {` ${String(publicKey)?.slice(0, 4)}...`}
              </Box>
            </HStack>
          </>
        ) : (
          "Connect Wallet"
        )}
      </Button>
      {/*       <Box>{publicKey}</Box> */}
    </div>
  );
};

export default ConnectButton;
